<script>
	import {
		generateConfigs,
		addClient,
		addWebsite,
		updateClient,
		generateGrids,
		disableClient
	} from '../api.js';
	import { currentUser } from '../utils.js';
	import { Checkbox, notifications, NotificationDisplay } from '@shopboxai/sb-portal-components';
	let createConfigs = true;
	let createGrids = true;
	let createWebsiteConfigs = true;
	let createWebsiteGrids = false;

	let newClient = {
		id: '',
		name: '',
		features: {
			grid_builder: false,
			open_api: false,
			widget_customization: false,
			go_live: false
		}
	};

	let newWebsite = {
		name: '',
		attr: '',
		client_id: ''
	};
	let updateClientInfo = {
		name: $currentUser.clientName,
		features: $currentUser.clientFeatures
	};

	let create = async () => {
		try {
			let res = await addClient(newClient);
			if (createConfigs) {
				await generateConfigs(newClient.id);
			}
			if (createGrids) {
				await generateGrids(newClient.id);
			}
			newClient = {
				id: '',
				name: '',
				features: {
					grid_builder: false,
					open_api: false,
					widget_customization: false,
					go_live: false
				}
			};
			notifications.success('Client created successfully', 2000);
		} catch (error) {
			notifications.danger(`${error}`, 2000);
		}
	};
	let add = async () => {
		try {
			const id = newWebsite.client_id + '-' + newWebsite.attr;
			let res = await addWebsite(newWebsite);
			if (createWebsiteConfigs) {
				await generateConfigs(id, newWebsite.client_id);
			}
			if (createWebsiteGrids) {
				await generateGrids(id);
			}
			newWebsite = {
				name: '',
				attr: '',
				client_id: ''
			};
			notifications.success('Website added successfully', 2000);
		} catch (error) {
			notifications.danger(`${error}`, 2000);
		}
	};

	let update = async () => {
		try {
			let res = await updateClient(updateClientInfo, $currentUser.clientId);
			notifications.success('User updated successfully', 2000);
		} catch (error) {
			notifications.danger(`${error}`, 2000);
		}
	};
	let disable = async () => {
		try {
			let res = await disableClient($currentUser.clientId);
			notifications.success('Client disabled successfully', 2000);
		} catch (error) {
			notifications.danger(`${error}`, 2000);
		}
	};
	const createAutoId = () => {
		const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

		let autoId = '';

		for (let i = 0; i < 20; i++) {
			autoId += CHARS.charAt(Math.floor(Math.random() * CHARS.length));
		}
		newClient.id = autoId;
	};
</script>

<main>
	<section class="form-wrapper">
		<form action="" on:submit|preventDefault={create}>
			<div>
				<h2>Add client</h2>
				<Checkbox labelText="Generate default configs" bind:value={createConfigs} />
				<Checkbox labelText="Generate find similar grid" bind:value={createGrids} />
				<label for="">Client ID</label>
				<div class="client-id">
					<input type="text" placeholder="Enter client id" bind:value={newClient.id} />
					<button
						class="auto-id-btn"
						class:hidden={newClient.id !== ''}
						on:click|preventDefault={createAutoId}>Auto ID</button
					>
				</div>
				<label for="">Client Name</label>
				<input type="text" placeholder="Enter client name" bind:value={newClient.name} />
				<Checkbox labelText="Grid Builder" bind:value={newClient.features.grid_builder} />
				<Checkbox labelText="Open Api" bind:value={newClient.features.open_api} />
				<Checkbox
					labelText="Widget Customization"
					bind:value={newClient.features.widget_customization}
				/>
				<Checkbox labelText="Go Live" bind:value={newClient.features.go_live} />
			</div>

			<button class="primary">Add client</button>
		</form>
		<form action="" on:submit|preventDefault={add}>
			<div>
				<h2>Add website (locale)</h2>
				<Checkbox labelText="Copy configs from main client" bind:value={createWebsiteConfigs} />
				<Checkbox labelText="Generate find similar grid" bind:value={createWebsiteGrids} />

				<label for="">Client Name Affix </label>
				<input type="text" placeholder="UK" bind:value={newWebsite.name} />
				<label for="">Client Locale</label>
				<input type="text" placeholder="uk" bind:value={newWebsite.attr} />
				<label for="">Client ID</label>
				<input type="text" placeholder="CID" bind:value={newWebsite.client_id} />
			</div>

			<button class="primary">Add website</button>
		</form>
		<form action="" on:submit|preventDefault={update}>
			<div>
				<h2>Update current client</h2>
				<label for="">Edit client name</label>
				<input type="text" bind:value={updateClientInfo.name} />
				<h4>Edit client features</h4>
				{#each Object.entries(updateClientInfo.features) as [key, val]}
					<Checkbox
						labelText={key.split('_').join(' ')}
						bind:value={updateClientInfo.features[key]}
					/>
				{/each}
			</div>

			<button class="primary">Update</button>
		</form>
		<form action="" on:submit|preventDefault={disable}>
			<div>
				<h2>Disable current client</h2>
				<button class=" primary danger">Disable</button>
			</div>
		</form>
	</section>
	<NotificationDisplay />
</main>

<style>
	h2 {
		font-family: 'Chivo', serif;
		margin-bottom: 1em;
	}
	h4 {
		margin-bottom: 0.5em;
	}
	main {
		width: 100%;
		margin: 0 auto;
	}
	.form-wrapper {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}
	form {
		flex-basis: 45%;
		margin-bottom: 1.5em;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: flex-start;
	}
	form > div {
		width: 100%;
	}
	label {
		display: inline-block;
		color: var(--t-c);
	}

	input[type='text'] {
		display: block;
		width: 100%;
		padding: 12px 16px;
		border: 1px solid var(--brd-l);
		border-radius: 5px;
		color: var(--t-c);
		font-size: 15px;
		line-height: 1.5;
		margin-bottom: 1em;
	}
	.client-id {
		position: relative;
	}
	.auto-id-btn {
		position: absolute;
		top: 2px;
		right: 2px;
		font-size: 16px;
		color: var(--l-c);
		height: 93%;
		width: 85px;
	}
	.auto-id-btn:hover {
		background-color: var(--bg-c);
		border-radius: 4px;
	}
	.hidden {
		display: none;
	}
	@media (max-width: 750px) {
		.form-wrapper {
			flex-direction: column;
		}
	}
</style>
